import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import moment from 'moment';
import Base from '../js/base';
import Utils from '../js/utils';
export default (function (props, _ref) {
  var $ = _ref.$,
      $f7 = _ref.$f7,
      $tick = _ref.$tick,
      $update = _ref.$update;
  var page_name = 'vipham-noiquy';
  var pn = "div[data-name=\"".concat(page_name, "\"]");
  var id_emp = Base.user.id;
  var total_so_tien = 0,
      rows = [],
      rs,
      recent_rows = [];

  _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var month, yrs;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            month = moment().subtract(1, 'days').format('YYYY-MM');
            _context.next = 3;
            return Base.call({
              method: '_get',
              table: 'nvut_baocao',
              params: {
                fields: 'nvut_baocao.*, nvut_tieuchi.name',
                join: 'JOIN nvut_tieuchi ON nvut_tieuchi.id = nvut_baocao.id_tieuchi',
                where: 'id_emp=:id_emp AND ngay LIKE :month AND ngay < :today',
                where_data: {
                  id_emp: id_emp,
                  month: "".concat(month, "%"),
                  today: moment().format('YYYY-MM-DD')
                },
                order: 'created_at DESC'
              }
            });

          case 3:
            yrs = _context.sent;

            if (!(yrs.rows.length === 0)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return");

          case 6:
            recent_rows = yrs.rows;
            $update();

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }))();

  var chitiet = function chitiet(e) {
    var id = parseInt($(e.target).data('id'));
    var rows_chitiet = rs.rows.filter(function (r) {
      return r.id_tieuchi === id;
    });
    var content = rows_chitiet.map(function (row) {
      return "<div>".concat(moment(row.created_at).format('D/M HH:mm'), "</div>");
    }).join('');
    $f7.dialog.create({
      title: "Ghi nh\u1EADn ".concat(rows_chitiet.length, " l\u1EA7n"),
      content: content,
      closeByBackdropClick: true
    }).open();
  }; // const monthChanged = e=>{
  //   $f7.dialog.prompt('Nhập tháng MM-YYYY', 'Điền thời gian', (value)=>{
  //     let x = value.split('-');
  //     month = `${x[1]}-${x[0]}`;
  //     rows = [];
  //     rs = null;
  //     $update(()=>list());
  //   },null,moment().subtract(1, 'months').format('MM-YYYY'));
  // }


  var list = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var month, times, _loop, id_tieuchi;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              month = moment().subtract(1, 'months').format('YYYY-MM');
              _context2.next = 3;
              return Base.call({
                method: '_get',
                table: 'nvut_baocao',
                params: {
                  fields: 'nvut_baocao.*, nvut_tieuchi.name',
                  join: 'JOIN nvut_tieuchi ON nvut_tieuchi.id = nvut_baocao.id_tieuchi',
                  where: 'id_emp=:id_emp AND ngay LIKE :ngay',
                  where_data: {
                    id_emp: id_emp,
                    ngay: "".concat(month, "%")
                  }
                }
              });

            case 3:
              rs = _context2.sent;

              if (!(rs.rows.length === 0)) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt("return");

            case 6:
              times = {};
              rs.rows.forEach(function (row) {
                if (times[row.id_tieuchi] === undefined) {
                  times[row.id_tieuchi] = 1;
                } else {
                  times[row.id_tieuchi] += 1;
                }

                total_so_tien += parseInt(row.so_tien);
              });

              _loop = function _loop(id_tieuchi) {
                var row = rs.rows.find(function (r) {
                  return r.id_tieuchi === parseInt(id_tieuchi);
                });
                rows.push({
                  name: row.name,
                  so_tien: row.so_tien,
                  times: times[id_tieuchi],
                  id_tieuchi: parseInt(id_tieuchi)
                });
              };

              for (id_tieuchi in times) {
                _loop(id_tieuchi);
              }

              rows.sort(function (a, b) {
                if (a.times > b.times) return -1;
                if (a.times < b.times) return 1;
                return 0;
              });
              $update();

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function list() {
      return _ref3.apply(this, arguments);
    };
  }();

  $tick(function () {
    return list();
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="${page_name}">
  <div class="page-content">

    <div class="card data-table ${recent_rows.length === 0 && 'display-none'}">
      <div class="card-header">Từ đầu tháng đến ngày ${moment().subtract(1, 'days').format('DD/MM')}, bạn đã KHÔNG:</div>
      <table>
        <tbody>
          ${recent_rows.length > 0 && recent_rows.map(row=>$h`
            <tr>
              <td>(${moment(row.created_at).format('DD/MM HH:mm')}) - ${row.name}</td>
            </tr>
          `)}
        </tbody>
      </table>
    </div>    

    <div class="card data-table ${rows.length === 0 && 'display-none'}">
      <div class="card-header">TỔNG KẾT THÁNG TRƯỚC (${moment().subtract(1, 'months').format('MM/YYYY')}), bạn đã KHÔNG:</div>
      <table>
        <tbody>
          ${rows.length > 0 && rows.map(row=>$h`
            <tr>
              <td><a @click="${chitiet}" data-id="${row.id_tieuchi}">${row.name}</a></td>
              <td class="numeric-cell">x${row.times}</td>
            </tr>
          `)}
        </tbody>
      </table>
    </div>

  </div>
</div>
`
    }
    ;
});